import { Button, Header, Text } from '@wework/dieter-ui'

import React from 'react'
import {
  ElevatorFoyerIcon,
  HotDeskIcon,
  ShowersIcon,
  GameRoomIcon,
  KitchenIcon,
  PrinterAlcoveIcon,
  StairsIcon,
  WellnessRoomIcon,
  LobbyIcon,
  MothersRoomIcon,
  RestRoomIcon,
  PhoneBoothIcon,
  CommunityBarIcon,
  HonestyMarketIcon,
  OutdoorTerraceIcon,
  ConferenceRoomsIcon,
} from '../Icons'
import Row from '../Common/Row'

import available from '../../assets/images/legend/available.png'
import unavailable from '../../assets/images/legend/unavailable.png'
import hold from '../../assets/images/legend/hold.png'
import unmapped from '../../assets/images/legend/unmapped.png'
import { useSidebar } from '../../hoc/withSidebar'

export default function Legend() {
  const { closeSideBar } = useSidebar()
  return (
    <>
      <div
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 6,
        }}
      >
        <Header as="h3" style={{ margin: 0 }}>
          Legend
        </Header>
        <Button basic onClick={closeSideBar} icon="close" />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'scroll',
          marginBottom: 12,
        }}
      >
        <Text style={{ marginTop: 20, fontWeight: '600' }}>Occupancy</Text>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <img src={available} />
          <Text style={{ marginLeft: 24 }} size="small">
            Available
          </Text>
        </Row>

        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <img src={unavailable} />
          <Text style={{ marginLeft: 24 }} size="small">
            Occupied
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <img src={hold} />
          <Text style={{ marginLeft: 24 }} size="small">
            Hold / Pending PPWK
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <img src={unmapped} />
          <Text style={{ marginLeft: 24 }} size="small">
            Not linked
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <div style={{ width: 24, height: 24 }}>📝</div>
          <Text style={{ marginLeft: 24 }} size="small">
            Notes
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <div style={{ width: 24, height: 24 }}>🚛</div>
          <Text style={{ marginLeft: 24 }} size="small">
            Move out
          </Text>
        </Row>

        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <div style={{ width: 24, height: 24 }}>🔒</div>
          <Text style={{ marginLeft: 24 }} size="small">
            Hold
          </Text>
        </Row>

        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <div style={{ width: 24, height: 24 }}>🔏</div>
          <Text style={{ marginLeft: 24 }} size="small">
            Pending PPWK
          </Text>
        </Row>

        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <div style={{ width: 24, height: 24 }}>🔌 </div>
          <Text style={{ marginLeft: 24 }} size="small">
            Not linked
          </Text>
        </Row>

        <Text style={{ marginTop: 20, fontWeight: '600' }}>Spaces</Text>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <ConferenceRoomsIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Meeting room
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <RestRoomIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Restroom
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <ShowersIcon color="#666666" />

          <Text size="small" style={{ marginLeft: 24 }}>
            Showers
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <HotDeskIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Hot / Dedicated Desk
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <PhoneBoothIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Phonebooth
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <MothersRoomIcon color="#666666" />

          <Text size="small" style={{ marginLeft: 24 }}>
            Mother’s room
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <GameRoomIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Game room
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <WellnessRoomIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Wellness room
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <CommunityBarIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Community bar
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <ElevatorFoyerIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Elevator foyer
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <LobbyIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Lobby
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <StairsIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Interior staircase
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <HonestyMarketIcon color="#666666" />{' '}
          <Text style={{ marginLeft: 24 }} size="small">
            Honesty market
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <OutdoorTerraceIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Outdoor terrace
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <KitchenIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Kitchen
          </Text>
        </Row>
        <Row style={{ marginTop: 20, justifyContent: 'flex-start' }}>
          <PrinterAlcoveIcon color="#666666" />
          <Text style={{ marginLeft: 24 }} size="small">
            Printing Alcove
          </Text>
        </Row>
      </div>
    </>
  )
}
